import React from 'react'
import { vn } from 'vend-number'
import {
  CashPaymentInformation,
  CashPaymentModal,
} from '../../../payments/cash-payment-modal/CashPaymentModal'
import { print } from '../../../print/print'
import { CashPaymentOption, SalePayment } from './types'

export const Cash = ({
  paymentOptions,
  onSuccess,
  onClose,
  currencySymbol,
}: {
  paymentOptions: CashPaymentOption
  onSuccess?: (result: SalePayment) => void
  onClose: () => void
  currencySymbol: string
}) => {
  const partialPayment = vn(paymentOptions.roundedAmountTendered.rounded)
    .abs()
    .lt(vn(paymentOptions.roundedBalance.rounded).abs())
  const rounding =
    paymentOptions.paymentType.config &&
    paymentOptions.paymentType.config.rounding
      ? paymentOptions.paymentType.config.rounding
      : '0.01'

  const openCashDrawer = () => {
    print({ type: 'open-drawer' })
  }

  return (
    <CashPaymentModal
      amountToPay={paymentOptions.roundedAmountTendered}
      balanceRemainder={paymentOptions.roundedBalance.remainder}
      close={result => {
        if (result) {
          result
            .then((data: CashPaymentInformation) => {
              if (onSuccess) {
                // FIXME: do stuff with cash payment info to convert that into SalePayment
              }
            })
            .catch(() => {
              // Handle error if needed
            })
            .finally(() => {
              // Close the modal
              onClose()
            })
        }
      }}
      currencySymbol={currencySymbol}
      isPartialPayment={partialPayment}
      openCashDrawer={openCashDrawer}
      rounding={vn(rounding)}
    />
  )
}
